<div class="bg-surface-card border border-stroke-soft rounded-xl p-6 flex flex-col gap-6">
  <div class="flex items-center justify-between">
    <div class="flex flex-col gap-3">
      <div class="h-6 w-56 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
      <div class="h-4 w-16 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
    </div>
    <div class="size-9 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
  </div>
  <div class="h-40 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
  <div class="h-24 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
</div>
